import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-plus",
  "use": "ico-plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"plusIconTitle\" id=\"ico-plus\"> <title id=\"ico-plus_plusIconTitle\">Plus</title> <path d=\"M20 12L4 12M12 4L12 20\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol